module.exports = __webpack_public_path__ + "img/open_icon.c8e5144a.png";